import Keycloak from 'keycloak-js'

var installed = false

export default {
  install: (Vue, params = {}) => {
    if (installed) return
    installed = true

    const defaultParams = {
      config: window.__BASEURL__ ? `${window.__BASEURL__}/config` : '/config',
      init: { onLoad: 'login-required' }
    }
    const options = Object.assign({}, defaultParams, params)
    if (assertOptions(options).hasError) throw new Error(`Invalid options given: ${assertOptions(options).error}`)

    const watch = Vue.observable({
      ready: false,
      authenticated: false,
      token: null,
      logout: null,
      login: null,
      idTokenParsed: null,
      resourceAccess: null,
      refreshToken: null
    })
    Object.defineProperty(Vue.prototype, '$keycloak', {
      get() {
        return watch
      }
    })
    getConfig(options.config)
      .then(config => {
        init(config, watch, options)
      })
      .catch(error => {
        console.error(error)
      })
  }
}

function init(config, watch, options) {
  // La 21 admite las dos formas y de la 22 en adelante 'new' es obligatorio,
  // asi que dejarlo asi no rompe hoy ni habra que tocarlo al subir de version.
  const keycloak = new Keycloak(config)

  keycloak.onReady = (authenticated) => {
    updateWatchVariables(authenticated)
    watch.ready = true
    typeof options.onReady === 'function' && options.onReady(keycloak)
  }
  keycloak.onAuthSuccess = () => {
    // Check token validity every 60 seconds (60000 ms) and, if necessary, update the token.
    // Refresh token if it's valid for less then 70 seconds
    const updateTokenInterval = setInterval(() => keycloak.updateToken(70).catch(() => {
      keycloak.clearToken()
    }), 60000)
    watch.logout = () => {
      clearInterval(updateTokenInterval)
      // A donde se vuelve tras cerrar sesion. Tiene que ser una URL de la
      // APLICACION, no la web corporativa: desde Keycloak 24 el
      // post_logout_redirect_uri se valida contra la lista del cliente, y
      // https://iciredimpagados.com no esta en ella. Con ese valor, cerrar
      // sesion devolvia "URL no valida" (HTTP 400 de Keycloak).
      //
      // VUE_APP_ICIRED_BASE_URL es la web corporativa y su sitio son los
      // enlaces del pie -condiciones, privacidad, cookies-, no esto.
      //
      // VUE_APP_KEYCLOACK_REDIRECT_URL ya estaba declarada para esto y no la
      // usaba nadie. En demo no esta definida, de ahi el respaldo a
      // window.location.origin, que es lo que keycloak-js usa por defecto.
      keycloak.logout({
        redirectUri: process.env.VUE_APP_KEYCLOACK_REDIRECT_URL || window.location.origin
      })
    }
  }
  keycloak.onAuthRefreshSuccess = () => {
    updateWatchVariables(true)
  }
  keycloak.onAuthRefreshError = () => {
    updateWatchVariables(false)
    typeof options.onAuthRefreshError === 'function' && options.onAuthRefreshError(keycloak)
  }
  keycloak.init(options.init).then((authenticated) => {
    updateWatchVariables(authenticated)
    typeof options.onInitSuccess === 'function' && options.onInitSuccess(authenticated)
  }).catch((err) => {

    updateWatchVariables(false)
    const error = Error('Could not initialized keycloak-js adapter')
    typeof options.onInitError === 'function' ? options.onInitError(error, err) : console.error(error, err);
    keycloak.logout();
  })

  function updateWatchVariables(isAuthenticated = false) {
    watch.authenticated = isAuthenticated
    watch.login = keycloak.login

    if (isAuthenticated) {
      watch.token = keycloak.token
      watch.idTokenParsed = keycloak.idTokenParsed
      watch.resourceAccess = keycloak.resourceAccess
      watch.refreshToken = keycloak.refreshToken
    }
  }
}

function assertOptions(options) {
  const { config, init, onReady, onInitError, onAuthRefreshError } = options
  if (typeof config !== 'string' && !_isObject(config)) {
    return { hasError: true, error: `'config' option must be a string or an object. Found: '${config}'` }
  }
  if (!_isObject(init) || typeof init.onLoad !== 'string') {
    return { hasError: true, error: `'init' option must be an object with an 'onLoad' property. Found: '${init}'` }
  }
  if (onReady && typeof onReady !== 'function') {
    return { hasError: true, error: `'onReady' option must be a function. Found: '${onReady}'` }
  }
  if (onInitError && typeof onInitError !== 'function') {
    return { hasError: true, error: `'onInitError' option must be a function. Found: '${onInitError}'` }
  }
  if (onAuthRefreshError && typeof onAuthRefreshError !== 'function') {
    return { hasError: true, error: `'onAuthRefreshError' option must be a function. Found: '${onAuthRefreshError}'` }
  }
  return {
    hasError: false,
    error: null
  }
}

function _isObject(obj) {
  return obj !== null && typeof obj === 'object' && Object.prototype.toString.call(obj) !== '[object Array]'
}

function getConfig(config) {
  if (_isObject(config)) return Promise.resolve(config)

  throw new Error(`Invalid config given`)
}
